import { Input, Checkbox, Select, SelectOption } from 'ui';
import { useIntl } from 'react-intl';
import useQueryApiClient from '../../../../../utils/useQueryApiClient';
import ImgCrop from 'antd-img-crop';
import { Form, Upload, FormInstance } from 'antd';
import { useState } from 'react';
import useFormValidation from '../../../../../../src/utils/useFormValidation';
import { extractUserNameSurname } from '../../../../../utils/extractUserNameSurname';

interface UserDataInterface {
  id?: number;
  name?: string | null;
  surname?: string | null;
  email?: string | null;
  phone?: number | null;
}

interface UserProfileInfoProps {
  form: FormInstance<any>;
}

export const UserProfileInfo = ({ form }: UserProfileInfoProps) => {
  const [image, setImage] = useState(form.getFieldValue('images') ?? []);

  const intl = useIntl();

  const { formValidations } = useFormValidation();

  const { data } = useQueryApiClient({
    request: {
      url: `/api/v2/users/list`,
    },
  });

  const setUserFormInformation = (email: string) => {
    if (!data) return;

    const selectedUser = data.find(
      (user: UserDataInterface) => user.email === email
    );

    if (selectedUser) {
      const nameAndSurname = extractUserNameSurname(selectedUser.name);

      form.setFieldsValue({
        name: selectedUser.surname
          ? selectedUser.name
          : nameAndSurname?.firstName,
        surname: selectedUser.surname ?? nameAndSurname?.lastName,
        phone: selectedUser.phone,
      });
    }
  };

  return (
    <div className={'inputs'}>
      <Form.Item
        name="images"
        valuePropName="fileList"
        rules={formValidations('required')}
      >
        <ImgCrop>
          <Upload
            name="images"
            listType="picture-card"
            fileList={image || form.getFieldValue('images')}
            customRequest={({ onSuccess }) => {
              // No API call
              onSuccess?.('ok');
            }}
            onRemove={() => {
              setImage([]);
            }}
            onChange={(el) => {
              const formattedImages = el.fileList.map(
                (file: any, index: number) => ({
                  uid: file.uid || `${Date.now()}-${index}`,
                  name: file.name,
                  status: 'done',
                  url: URL.createObjectURL(file.originFileObj),
                  originFileObj: file.originFileObj,
                })
              );

              setImage(formattedImages);
              form.setFieldsValue({ images: formattedImages });
            }}
          >
            {!image || (image.length == 0 && <span>+</span>)}
          </Upload>
        </ImgCrop>
      </Form.Item>

      <div className={'collum'}>
        <div className="half-collum">
          {intl.formatMessage({ id: 'register.name' })}
          <Input size={'large'} name={'name'} disabled />
        </div>
        <div className="half-collum">
          {intl.formatMessage({ id: 'register.surname' })}
          <Input size={'large'} name={'surname'} disabled />
        </div>
      </div>
      <div className="full-collum">
        {intl.formatMessage({ id: 'profile.email' })}
        <Select
          name="email"
          onChange={setUserFormInformation}
          validations={'required'}
        >
          {data.map((data: UserDataInterface) => (
            <SelectOption key={data.id} value={data.email}>
              {data.email}
            </SelectOption>
          ))}
        </Select>
      </div>
      <div className={'collum'}>
        <Checkbox
          label={intl.formatMessage({ id: 'profile.publish_email' })}
          name={'public_email'}
        />
      </div>
      <div className={'full-collum'}>
        {intl.formatMessage({ id: 'general.contact_phone' })}
        <Input
          size={'large'}
          name={'phone'}
          maxLength={8}
          validations={'phoneNumber'}
        />
      </div>
      <div className={'collum'}>
        <Checkbox
          label={intl.formatMessage({
            id: 'profile.publish_phone_number',
          })}
          name={'public_phone'}
        />
      </div>
    </div>
  );
};
